import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'

export type Props = {
  hovered: boolean
  isHeartRed: boolean
}

const InteractiveHeart: React.FC<Props> = ({ hovered, isHeartRed }) => {
  const themeContext = useContext(ThemeContext)

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={isHeartRed ? themeContext.colors.pink51 : 'none'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.50004 13.5L10.5858 19.5858C11.3669 20.3669 12.6332 20.3669 13.4143 19.5858L19.5 13.5C21.433 11.567 21.433 8.43304 19.5 6.50004C17.567 4.56704 14.433 4.56704 12.5 6.50004C12.2239 6.77618 11.7762 6.77618 11.5 6.50004C9.56704 4.56704 6.43304 4.56704 4.50004 6.50004C2.56704 8.43304 2.56705 11.567 4.50004 13.5Z"
        stroke={
          hovered || isHeartRed
            ? themeContext.colors.pink51
            : themeContext.colors.gray60
        }
      />
    </svg>
  )
}

export default InteractiveHeart
